import Avatar from '@mui/material/Avatar';
import Paper from '@mui/material/Paper';
import React, { useContext } from 'react';
import { Nav } from 'react-bootstrap';
import { useCookies } from 'react-cookie';
import StyledComponent from 'styled-components';

import { CookieValues, ModelNameEnum } from '../../types';
import { NavigationBarContext } from './NavigationBar';

const linkText = '#007BF9';
const linkTextSelected = '#FFFFFF';
const bgColor = '#FFF';

const NavListContainer = StyledComponent.div`
  a, .navbar-brand, .navbar-nav .nav-link
  {
    &:hover
    {
    color: black;
    }

    span
    {
      padding-right: 5px;
    }

    inline-size: fit-content;
    padding-right: 18px;
    color: ${linkText};
  }
  .nav-link
  {
    text-align: center;
    padding: 0.2rem 0.5rem;
    align-self: center;
  }
  .link-img
  {
    width: 30px;
    margin-right: 10px;
  }

  .active
  {
    color: ${linkTextSelected};
    background: #000;
    border-radius: 10px;

    &:hover
    {
      color: #FFF;
    }
  }

  .name
  {
    text-align: center;
    color: ${linkText};
    font-weight: 600;
  }

  .avatar
  {

    width: 120px;
    height: 120px;
    margin: auto;
    margin-top: 5px;
    border: 3px solid #cecfd1;
  }

  .navlist-container
  {
    flex-direction: column!important;
  }

  background: ${bgColor};
  height: 100%;
  position: fixed;
  z-index: 0;
  /*top: 0;*/
  left: 0;
  overflow-x: hidden;
  display: inline-block;

 
    width: 100%;
    height: fit-content;
    position: unset;
`;
function NavList() {
  const { navData, selectedNavItem, navigationItemOnSelect } = useContext(NavigationBarContext);

  const [cookies] = useCookies<'user', CookieValues>(['user']);

  const name = cookies.user ? `${cookies.user.firstName}` : '';

  return (
    <NavListContainer>
      <Paper elevation={3} variant="outlined">
        <Avatar
          alt="Profile image"
          src={cookies.user?.photo ?? require('../../asset/no-photo.png')}
          className="avatar"
        />
        {name.length > 1 && <p className="name">{name}</p>}
        <Nav
          activeKey={selectedNavItem ?? undefined}
          className="navlist-container"
          onSelect={eventKey => navigationItemOnSelect(eventKey as ModelNameEnum | null, false)}>
          {navData.map((item, i) => (
            <Nav.Link key={i} eventKey={item.title}>
              {item.icon.indexOf('.png') === -1 ? (
                <span className={item.icon} />
              ) : (
                <img className="link-img" alt="link" src={require(`../../asset/${item.icon}`)} />
              )}
              {item.displayName}
            </Nav.Link>
          ))}
        </Nav>
      </Paper>
    </NavListContainer>
  );
}

export default NavList;
